export default {"src":"/_next/static/media/espanha.bdd22b19.svg","height":26,"width":36};